/**
 * Tile Tabs WE — tiled tab layouts
 *
 * Exposes exactly one web-accessible resource, `quickmenu.html`, matched to every
 * http(s) origin with no `use_dynamic_url` — so it resolves from any page at a fixed
 * URL. With a single WAR there is no corroborating path, but the one that exists is a
 * stable, vendor-specific filename served only when the extension is installed, which
 * makes a successful fetch conclusive.
 *
 * Manifest verified against version 31.3.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'lbnnfjfjdijcnaakaebgcoemmlicjbnl';

export const tileTabsWe: ExtensionDefinition = {
  id: ID,
  name: 'Tile Tabs WE',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 80_000,
  notes:
    'A single static WAR (quickmenu.html) on every http(s) origin, no dynamic URL. ' +
    'One path only, but a successful fetch is conclusive.',
  signals: [
    {
      id: 'war-quickmenu-html',
      kind: 'web-accessible-resource',
      description:
        'Fetch quickmenu.html — the extension\'s only web-accessible resource, exposed ' +
        'to every http(s) origin at a fixed URL.',
      weight: 1,
      run: () => probeFetch(ID, 'quickmenu.html'),
    },
  ],
};
